/* eslint-disable */
import React, {useEffect, useState} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Divider,
    Grid,
    Button,
    Slide,
    InputLabel,
    TextField,
    DialogActions,
} from "@mui/material"
import {useDataParams} from "../hooks/useDataParams";
import {useDispatch, useSelector} from "react-redux";
import {$crud} from "../services/CrudFactory";
import {Visibility} from "@mui/icons-material";


export const OtpManagerModal = (props) => {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false)
    const {params, handleChange, setParams} = useDataParams();
    const {open, onClose, onSubmit} = props;

    const cancel = () => {
        onClose();
        setParams({});
    }


    const onShow = () =>{
        setShowPassword(!showPassword);
    }
    // const retrieveUrl = async () => {
    //     try {
    //         dispatch({
    //             type: "LOADER",
    //             loader: true
    //         });
    //         const {data} = await $crud.retrieve("web/server-user-url",{id:props?.id});
    //         return data;
    //     } catch (e) {
    //         dispatch({
    //             type: "SNACKBAR",
    //             snackBar: {type: "error", message: e.message}
    //         })
    //     } finally {
    //         dispatch({
    //             type: "LOADER",
    //             loader: false
    //         });
    //     }
    // }

    // const handleSubmit = async () =>{
    //     try {
    //         dispatch({
    //             type: "LOADER",
    //             loader: true
    //         });
    //         const {type, message, data} = await $crud.post(
    //             !props?.id ? "create/web/server-user-url" : "update/web/server-user-url",{
    //                 ...params
    //             }
    //         );
    //
    //         dispatch({
    //             type: "SNACKBAR",
    //             snackBar: {type, message},
    //         });
    //         // retrieveUsers().then(res=>{
    //         //     dispatch(users(res.users))
    //         // })
    //         onSubmit(data);
    //         cancel();
    //     } catch (e) {
    //         dispatch({
    //             type: "SNACKBAR",
    //             snackBar: {type: "error", message: e.message}
    //         })
    //     } finally {
    //         dispatch({
    //             type: "LOADER",
    //             loader: false
    //         });
    //     }
    // }

    return (
        <Dialog maxWidth={"xs"} TransitionProps={
            {
                onEnter: () => {
                }
            }
        } TransitionComponent={Slide} fullWidth open={open}>
            <div className="tableHeader-color">
                <DialogTitle>Api key for Otp Manager</DialogTitle>
                <Divider/>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Grid container justifyContent="space-between" alignItems="center">
                                <InputLabel className="mb-1">Api Key <span>*</span></InputLabel>
                            </Grid>
                            <TextField
                                required
                                size="small"
                                value={params?.otpApiKey || ""}
                                // type={showPassword ? "text" : "password"}
                                onChange={(e) => handleChange("otpApiKey", e.target.value)}
                                // InputLabelProps={{shrink: true}}
                                // InputProps={{
                                //     endAdornment: <Visibility id="eye-btn" onClick={onShow}></Visibility>
                                // }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent="space-between" alignItems="center">
                                <InputLabel className="mb-1">Instructions</InputLabel>
                            </Grid>
                            <TextField
                                size="small"
                                value={params?.instructions || ""}
                                // type={showPassword ? "text" : "password"}
                                onChange={(e) => handleChange("instructions", e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={cancel} color="primary" size="small">Cancel</Button>
                    <Button className="ms-2" onClick={()=>{onSubmit(params)}} variant="contained" color="primary" size="small">Submit</Button>
                </DialogActions>
            </div>
        </Dialog>
    );
};
